import type { ProductNicotineStrength } from "@magento/types";

export const normalizeProductNicotineStrengthData = (
  details: ProductNicotineStrength | null | undefined
): ProductNicotineStrength | undefined => {
  if (!details || details.rating <= 0) {
    return undefined;
  }

  return details;
};
